module.exports = __webpack_public_path__ + "img/product-33.4232475f.jpg";